import { useCallback } from 'react';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface DeleteReceiptRequest {
  receiptIds?: any[];
}

const useDeleteReceiptsApi = () => {
  const call = useCallback(async ({ receiptIds }: DeleteReceiptRequest = {}) => {
    try {
      return await axiosInstance.post(`/Receipt/Delete`, receiptIds);
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute } = useAsync(call, false);

  return { deleteReceipts: execute, deleteReceiptsLoading: isLoading };
};

export default useDeleteReceiptsApi;
